module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison/2020/desktop.svg?v=607c3f5c";